<template>
  <div class="nuclear-binding-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$E = Δmc²$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 混合仿真：核子结合演示 -->
      <div class="canvas-item simulation">
         <svg width="100%" height="240" viewBox="0 0 400 240">
            <!-- 自由核子 -->
            <g v-if="state === 'separated'">
               <circle v-for="n in 8" :key="'sn'+n" 
                 :cx="pPositions[n-1].x" :cy="pPositions[n-1].y" r="8" 
                 :fill="n % 2 === 0 ? '#ff4757' : '#00d2ff'" />
               <text x="50" y="220" fill="#888" font-size="10">自由核子：总质量 M₁</text>
            </g>

            <!-- 结合后的原子核 -->
            <g v-else transform="translate(250, 120)">
               <circle v-for="n in 8" :key="'kn'+n" 
                 :cx="pOffsets[n-1].x" :cy="pOffsets[n-1].y" r="8" 
                 :fill="n % 2 === 0 ? '#ff4757' : '#00d2ff'" />
               <text x="-50" y="80" fill="#ffd700" font-size="10">结合态：总质量 M₂ < M₁</text>
               <circle r="40" fill="none" stroke="#ffd700" stroke-width="1" stroke-dasharray="4,2">
                  <animate attributeName="opacity" values="0.2;0.8;0.2" dur="2s" repeatCount="indefinite" />
               </circle>
            </g>

            <!-- 能量释放箭头 -->
            <path v-if="state === 'fused'" d="M 200 120 L 350 50 M 200 120 L 350 190" stroke="#ffd700" stroke-width="2" marker-end="url(#energy-arr)" />
         </svg>

         <div class="hud-center" v-if="state === 'fused'">
            <div class="energy-flash">ENERGY RELEASED</div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="action-card">
            <el-button type="primary" size="mini" @click="toggleState">
               {{ state === 'separated' ? '使核子结合' : '分解核子' }}
            </el-button>
         </div>

         <div class="theory-note">
            <p><strong>爱因斯坦质能方程：</strong>核子结合成原子核时，由于强相互作用释放能量，总质量会减少。这个<strong>质量亏损</strong> Δm 对应的能量 Δmc² 就是结合能。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NuclearBindingViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      state: 'separated',
      pPositions: Array.from({ length: 8 }, () => ({
        x: 50 + Math.random() * 100,
        y: 50 + Math.random() * 140
      })),
      pOffsets: [
         {x:-10, y:-10}, {x:10, y:-10}, {x:-10, y:10}, {x:10, y:10},
         {x:0, y:-4}, {x:-4, y:0}, {x:4, y:0}, {x:0, y:14}
      ]
    }
  },
  watch: {
    knowledgePoint: {
      handler() { this.detectMode(); },
      immediate: true
    }
  },
  methods: {
    detectMode() {
      const kp = this.knowledgePoint || '';
      if (/结合|核能|亏损/.test(kp)) this.state = 'fused';
      else this.state = 'separated';
    },
    toggleState() {
       this.state = this.state === 'separated' ? 'fused' : 'separated';
    }
  }
}
</script>

<style scoped lang="scss">
.nuclear-binding-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #ffd700; background: rgba(255,215,0,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-item { 
   background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-center { position: absolute; top: 20%; right: 10%; .energy-flash { color: #ffd700; font-weight: bold; font-size: 1rem; text-shadow: 0 0 10px #ffd700; animation: bounce 1s infinite; } }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.action-card { background: rgba(255,255,255,0.03); padding: 15px; border-radius: 12px; display: flex; justify-content: center; }
.theory-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
@keyframes bounce { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.1); } }
</style>
